import React from 'react';
import { useLocation } from 'react-router-dom';
import ReactAuthOutlet from '@auth-kit/react-router/AuthOutlet';
import Navbar from '../components/Navbar';
import ThemeContextProvider from './ThemeProvider';

const AuthOutlet = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const hasUserId = params.has("userId");

  return (
    <ThemeContextProvider>
      <Navbar>
        {hasUserId ? (
          <ReactAuthOutlet />
        ) : (
          <ReactAuthOutlet fallbackPath="/signup" />
        )}
      </Navbar>
    </ThemeContextProvider>
  );
};

export default AuthOutlet;
